import { render, staticRenderFns } from "./TransferTab.vue?vue&type=template&id=656a6ea2&"
import script from "./TransferTab.vue?vue&type=script&lang=ts&"
export * from "./TransferTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('656a6ea2')) {
      api.createRecord('656a6ea2', component.options)
    } else {
      api.reload('656a6ea2', component.options)
    }
    module.hot.accept("./TransferTab.vue?vue&type=template&id=656a6ea2&", function () {
      api.rerender('656a6ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/TransferTab.vue"
export default component.exports